function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 7.8,
  y: 24.7,
  width: 131.2,
  height: 97.3
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_3_",
  x: 7.8,
  y: 24.7,
  width: 131.2,
  height: 97.3
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_5_",
  x: 7.8,
  y: 24.7,
  width: 131.2,
  height: 97.3
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_7_",
  x: 7.8,
  y: 24.7,
  width: 131.2,
  height: 97.3
}));

var SvgIcoRivemo = function SvgIcoRivemo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    width: "146px",
    height: "146px",
    viewBox: "0 0 146 146",
    style: {
      enableBackground: "new 0 0 146 146"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009FE3"
    },
    d: "M120,146H26c-14.3,0-26-11.7-26-26V26C0,11.7,11.7,0,26,0h94c14.3,0,26,11.7,26,26v94 C146,134.3,134.3,146,120,146z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref2, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M49.6,49.3L9.4,66.7c0,0-4.5,2.1,1.9,6.9s10.4,3.4,14.6,1.7 c4.3-1.7,28.2-12.1,28.2-12.1L49.6,49.3z"
  })), /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#FFFFFF"
    },
    d: "M57.1,63.4L26.2,76.7c0,0-4.5,2.1,1.9,6.9s10.4,3.4,14.6,1.7 c4.3-1.7,18.9-8.1,18.9-8.1L57.1,63.4z"
  })), /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#FFFFFF"
    },
    d: "M74.5,73.1L43.6,86.4c0,0-4.5,2.1,1.9,6.9s10.4,3.4,14.6,1.7 c4.3-1.7,18.9-8.1,18.9-8.1L74.5,73.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBCA00"
    },
    d: "M135.3,95.8L76,121.5c-3.1,1.4-6.8-0.1-8.1-3.2L42.2,59c-1.4-3.1,0.1-6.8,3.2-8.1l59.2-25.7 c3.1-1.4,6.8,0.1,8.1,3.2l25.7,59.2C139.8,90.7,138.4,94.4,135.3,95.8"
  }), /*#__PURE__*/React.createElement("g", null, _ref5, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#009FE3"
    },
    d: "M91.7,72.8c1.1-0.5,2-1,2.7-1.4c0.7-0.5,1.2-1,1.6-1.5s0.6-1,0.8-1.5 c0.2-0.5,0.4-1.1,0.5-1.6c0.5-1.4,0.7-2.8,0.7-4.3c0-1.4-0.4-2.9-1-4.3c-0.2-0.5-0.5-0.9-0.9-1.4c-0.4-0.4-0.9-0.8-1.4-1.1 s-1-0.4-1.6-0.5s-1.1,0-1.7,0.3l-8.2,3.6l1.9,16.5L91.7,72.8z M94.6,82.3l-8.2,3.6l1.7,14.3l-12.9,5.6l-5.9-50.3l22.5-9.8 c1.5-0.7,3.1-1.1,4.8-1.4c1.7-0.3,3.3-0.2,4.9,0.1s3,0.9,4.3,1.9c1.3,0.9,2.3,2.3,3.1,4c1,2.3,1.7,4.8,2,7.4 c0.3,2.6,0.3,5.1-0.2,7.7c-0.3,1.8-0.8,3.7-1.5,5.5s-1.6,3.5-2.8,4.9L117,87.7l-12.5,5.5L94.6,82.3z"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoRivemo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-rivemo.f8f961fb.svg";
export { ForwardRef as ReactComponent };